import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/gnc1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/gnc3.png'
import srj4 from '../../images/srj4.png'
import srj5 from '../../images/srj5.png'
import srj6 from '../../images/srj6.png'
import srj7 from '../../images/gnc7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/gnc10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const GNC = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Export-Ready Website & AI- <br/> First SEO for GNC Exports</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>30+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Technical & Industrial Manufacturer</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Madhur owns GNC Exports, a leading Indian <br/> manufacturer-exporter of technical and industrial <br/> textiles. The company recently launched a <br/> recycled/sustainable fabric line aimed at global <br/> B2B buyers.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>Although GNC Exports had a solid business foundation in India, the company faced challenges in scaling globally:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Strong domestic sales but limited global visibility, especially across Africa, UAE, and Saudi Arabia.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>The new recycled fabric line had high international potential but low awareness and no targeted digital presence.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>First time investing in digital—needed a ground-up website, search visibility, and an export-focused plan to generate qualified RFQs, not just traffic.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0 max_900">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Madhur shared that this would be their first digital marketing initiative. Priority: build a credible, fast, export-ready website and an AI-SEO strategy that earns visibility on Google SERPs and AI platforms, while mapping content to export buyers in Africa and the Gulf.</p>
                                    
                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>How to rank on Google and surface in AI results for technical/industrial and recycled fabrics.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Which export-intent keywords to prioritize (quality leads over volume).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A detailed roadmap to scale SEO and win leads from Africa, the UAE, and KSA.</li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 text-center">
                                        <img src={srj7} alt="srj3" className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                        </section>
                        

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <p className='heading_description text-dark mb-0'>Although GNC Export already has a good reputation in India but when we think of the global and export market, then for the market, GNC Export is a new brand. There are the following challenges that we have seen:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Fragmented product naming across catalogs; unclear information architecture for buyers.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Need for geo-specific credibility (market pages, trade documents, logistics info).</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Recycled fabric queries are split between sustainability narratives and technical specs, risking intent mismatch.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Zero prior CWV/speed optimizations; no structured data; thin content for AI/answer engines.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Discovery, Diagnosis & Keyword Strategy</div>
                                                <p>Interviewed sales and production teams; mapped buyer intents (procurement, OEM, distributors). And built an export-intent keyword set.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Website Development</div>
                                                <p>We have built a UI, and after getting the approval from the client, we have developed a high-speed website with lead magnets to get high-quality leads.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content Strategy</div>
                                                <p>For the content part, we have focused on the Pillars & Clusters, creating the Buyer's guide, and checklist-type content, which helped us in building the authority on the internet.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI-SEO (Answer Engine & Generative Optimization)</div>
                                                <p>For the AI SEO, we had to make sure that we implement proper Structured Q&A blocks, Schema Markup, and E-E-A-T Signals so that AI platforms mention GNC Exports.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page Optimization & Internal Linking</div>
                                                <p>Internal Links: From educational content → category pages → RFQ funnel; country pages link to suitable spec lines.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Backlink Foundations</div>
                                                <p>We have built high-quality backlinks which have high DA/PA, which have helped in the AI citations.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics & Ops</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Want to expand your manufacturing business <br/> globally?</>} title2={<>Let us build your AI SEO and export-focused strategy.</>} />
                    
                    <section className="intro_about_section section_space project_outcome max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>High Converting Website</div>
                                                <p>New export-grade website launched with clear IA, fast load times, and conversion-ready RFQ paths.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Google Ranking</div>
                                                <p>Ranking in the top 10 in almost every target keyword.</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Good Indexing</div>
                                                <p>Indexed market pages for Africa, UAE, and KSA; early SERP gains on geo-modified queries.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Brand Mentions in AI Platforms</div>
                                                <p>Recycled fabric content started appearing in AI overviews/answer modules for core informational queries.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Increase Lead Flow</div>
                                                <p>Increase in qualified enquiries: more detailed RFQs (specs, volumes, destinations) vs. generic inquiries.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Better Quality Leads</div>
                                                <p>Sales team reports shorter pre-qualification cycles due to better form data and downloadable docs.</p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default GNC;
